import { type RouteRecordRaw } from 'vue-router'

export const customersRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        children: [
          {
            component: async () =>
              import('../views/details/panels/CustomerDetailsRecentOrders.vue'),
            meta: {
              title: 'customers',
            },
            name: 'brand.customers.detail.orders',
            path: 'orders',
            props: true,
          },
          {
            component: async () =>
              import('../views/details/panels/CustomerDetailsReviews.vue'),
            meta: {
              title: 'customers',
            },
            name: 'brand.customers.detail.reviews',
            path: 'reviews',
            props: true,
          },
        ],
        component: async () =>
          import('../views/details/CustomerDetailsView.vue'),
        name: 'brand.customers.detail',
        path: ':customerId',
        props: true,
        redirect: { name: 'brand.customers.detail.orders' },
      },
      {
        component: async () =>
          import('../views/details/CustomerDetailsView.vue'),
        meta: {
          title: 'customers',
        },
        name: 'brand.customers.main',
        path: '',
        props: true,
      },
    ],
    component: async () => import('../views/CustomersViewRouter.vue'),
    meta: {
      permissions: [{ operation: 'read', resource: 'customer' }],
      scopes: ['customers:read'],
      title: 'customers',
    },
    name: 'brand.customers',
    path: 'customers',
  },
]
